var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculateRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4478_11489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4478_11489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 8.00232C15.625 12.2137 12.2112 15.6277 8.00002 15.6277C3.78886 15.6277 0.375015 12.2137 0.375015 8.00232C0.375015 3.79093 3.78886 0.376953 8.00002 0.376953C12.2112 0.376953 15.625 3.79093 15.625 8.00232Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29003 5.60733C5.14121 5.97278 4.78244 6.23039 4.36349 6.23039C3.81121 6.23039 3.36349 5.7827 3.36349 5.23043C3.36349 4.67817 3.81121 4.23047 4.36349 4.23047C4.78389 4.23047 5.14369 4.48987 5.29157 4.85733H9.41539C10.3924 4.85733 11.1844 5.64932 11.1844 6.62629C11.1844 7.60326 10.3924 8.39526 9.41539 8.39526H6.57067C6.01491 8.39526 5.56438 8.84579 5.56438 9.40155C5.56438 9.95731 6.01492 10.4078 6.57068 10.4078H10.7033C10.8502 10.0385 11.211 9.77734 11.6328 9.77734C12.1851 9.77734 12.6328 10.225 12.6328 10.7773C12.6328 11.3296 12.1851 11.7773 11.6328 11.7773C11.2152 11.7773 10.8575 11.5214 10.7077 11.1578H6.57068C5.6007 11.1578 4.81438 10.3715 4.81438 9.40155C4.81438 8.43158 5.6007 7.64526 6.57067 7.64526H9.41539C9.97815 7.64526 10.4344 7.18905 10.4344 6.62629C10.4344 6.06353 9.97815 5.60733 9.41539 5.60733H5.29003Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4478_11489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.56,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4478_11489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.0007,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculateRoute);
export default __webpack_public_path__ + "static/media/calculate-route.f42cc4709e950de5857d617d719126f4.svg";
export { ForwardRef as ReactComponent };